import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=51d086b0&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"
import style0 from "./navigation.vue?vue&type=style&index=0&id=51d086b0&prod&scoped=true&lang=css"
import style1 from "./navigation.vue?vue&type=style&index=1&id=51d086b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d086b0",
  null
  
)

export default component.exports